// Triggered in PathBlockContainer

import { ON_CORRECT_BLOCK_ORDER } from '../state-constants/stateConstants';

export const onCorrectBlockOrder = (bool) => ({
  type: ON_CORRECT_BLOCK_ORDER,
  payload: bool,
});



// WEBPACK FOOTER //
// ./src/state-actions/onCorrectBlockOrder.js